module.exports = __webpack_public_path__ + "img/changZuiHu1.46fdfdcc.png";